"use client";

import { FormLabel } from "@/shared/components/ui/form";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/shared/components/ui/tooltip";
import { HelpCircle } from "lucide-react";

interface FormFieldLabelProps {
    label?: string | React.ReactNode;
    labelType?: "text" | "tooltip";
    tooltipContent?: string;
}

export function FormFieldLabel({ label, labelType = "text", tooltipContent }: FormFieldLabelProps) {
    if (!label) return null;

    if (typeof label !== "string") return label;

    if (labelType === "tooltip" && tooltipContent) {
        return (
            <FormLabel>
                <div className="flex items-center gap-2">
                    <span>{label}</span>
                    <Tooltip>
                        <TooltipTrigger asChild>
                            <span className="cursor-help">
                                <HelpCircle className="h-4 w-4 text-muted-foreground" />
                            </span>
                        </TooltipTrigger>
                        <TooltipContent>
                            <p className="max-w-xs">{tooltipContent}</p>
                        </TooltipContent>
                    </Tooltip>
                </div>
            </FormLabel>
        );
    }

    return <FormLabel>{label}</FormLabel>;
}
